export const POST_AUTH_REDIRECT_KEY = "sayitinsports_post_auth_redirect";

export const sanitizeRedirect = (value?: string | null) => {
  if (!value || !value.startsWith("/") || value.startsWith("//")) return null;
  return value.split("#")[0] || "/";
};

export const buildPostAuthPath = (redirectTo: string, isAthlete: boolean) => {
  const params = new URLSearchParams({ next: redirectTo });
  if (isAthlete) params.set("as", "athlete");
  return `/auth?${params.toString()}`;
};